export function getDefaultOptions() {
    return {
        showNotifyElementsSelector: `.icon-info-circle`,
        closeNotifyElementsSelector: `.close-panel`,
        tooltipElementSelector: `.tooltip-info`,
        notifySelector: `.notification`,
        showClass: `show`,
    };
}

export function initialize(_options = getDefaultOptions()) {
    console.log("Initialize tooltip manager.");

    const options = _options;

    const showTooltip = element => {
        const cfElement = element.closest(options.tooltipElementSelector);

        if (!cfElement) {
            console.warn(`The closest element ${options.tooltipElementSelector} of ${element} was not found.`);
            return;
        }

        const notification = cfElement.querySelector(options.notifySelector);

        if (!notification) {
            console.log("No notification.");
            return;
        }

        notification.classList.add(options.showClass);
    }

    const hideTooltip = element => {
        const notification = element.closest(options.notifySelector);

        if (notification) {
            notification.classList.remove(options.showClass);
        }
    }

    document.addEventListener(`DOMContentLoaded`, e => {
        document.querySelectorAll(options.showNotifyElementsSelector).forEach(btn => {
            btn.addEventListener(`click`, evt => {
                showTooltip(btn);
            });
        });

        document.querySelectorAll(options.closeNotifyElementsSelector).forEach(btn => {
            btn.addEventListener(`click`, evt => {
                hideTooltip(btn);
            })
        })
    });

    console.log("Tooltip manager initialized");
}